// ModalDislikeButton.tsx

import * as React from "react";
import { useState, useEffect } from "react";
import { Checkbox, TextArea, Popup } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";

import { useUser } from "../../../contexts/useUserData";

import styles from "../buttonAndModalStyles.module.css";

interface propData {
    submitData: (formData: any) => Promise<void>;
    statusModal: Function;
    index: number;
}

type CheckboxValue = boolean | undefined;

export const ModalDislikeButton = (props: propData) => {
    const [valueTextAreaContent, setValueTextAreaContent] = useState<string>("");
    const [valueTextAreaLinks, setValueTextAreaLinks] = useState<string>("");
    const [valueTextAreaReason, setValueTextAreaReason] = useState<string>("");
    const { seccion } = useUser();

    const [checkedValueContent, setcheckedValueContent] = useState<CheckboxValue>(undefined);
    const [checkedValueLinks, setcheckedValueLinks] = useState<CheckboxValue>(undefined);
    const [checkedValueReason, setcheckedValueReason] = useState<CheckboxValue>(undefined);
    const [areCheckboxesChecked, setAreCheckboxesChecked] = useState<boolean>(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // New state

    const checkIfAnyCheckboxIsChecked = () => {
        return (
            checkedValueContent !== undefined ||
            checkedValueLinks !== undefined ||
            checkedValueReason !== undefined
        );
    };

    useEffect(() => {
        setAreCheckboxesChecked(checkIfAnyCheckboxIsChecked());
    }, [checkedValueContent, checkedValueLinks, checkedValueReason]);

    const handleCheckboxChange = (value: CheckboxValue, option: string) => {
        switch (option) {
            case "content":
                setcheckedValueContent(value);
                break;
            case "links":
                setcheckedValueLinks(value);
                break;
            case "reason":
                setcheckedValueReason(value);
                break;
            default:
                break;
        }
    };

    const handleCheckboxClick = (value: CheckboxValue, option: string) => {
        if (
            (option === "content" && value !== checkedValueContent) ||
            (option === "links" && value !== checkedValueLinks) ||
            (option === "reason" && value !== checkedValueReason)
        ) {
            handleCheckboxChange(value, option);
        } else {
            handleCheckboxChange(undefined, option);
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (isSubmitting) return; // Prevent multiple submissions

        if (!areCheckboxesChecked) {
            setIsPopupOpen(true);
            return;
        }

        setIsSubmitting(true); // Start submitting
        const submitClickTime = Date.now(); // Capturamos el tiempo de clic aquí
        const formData = {
            FeedbackCheckboxContent: checkedValueContent,
            FeedbackCheckboxLinks: checkedValueLinks,
            FeedbackCheckboxReason: checkedValueReason,
            FeedbackCommentContent: valueTextAreaContent,
            FeedbackCommentLinks: valueTextAreaLinks,
            FeedbackCommentReason: valueTextAreaReason,
            submitClickTime: submitClickTime // Añadimos el tiempo de clic a los datos del formulario
            
        };

        try {
            await props.submitData(formData);

            setcheckedValueContent(undefined);
            setcheckedValueLinks(undefined);
            setcheckedValueReason(undefined);
            setValueTextAreaContent("");
            setValueTextAreaLinks("");
            setValueTextAreaReason("");

            setIsFormSubmitted(true);
            setIsSubmitting(false); // End submitting
        } catch (error) {
            console.error("Error submitting dislike feedback:", error);
            setIsSubmitting(false); // End submitting even if there's an error
        }
    };

    let sections;

    sections = [
        {
            label: "Enlace documento",
            option: "links",
            checkboxValue: checkedValueLinks,
            textareaValue: valueTextAreaLinks,
            placeholder: "",
            handleTextareaChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => setValueTextAreaLinks(e.target.value),
            shouldRenderTextarea: false
        },
        {
            label: "Información proporcionada",
            option: "reason",
            checkboxValue: checkedValueReason,
            textareaValue: valueTextAreaReason,
            placeholder: "Dinos brevemente qué consideras que está mal",
            handleTextareaChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => setValueTextAreaReason(e.target.value),
            shouldRenderTextarea: true
        },
    ];

    return (
        <div id={`modalDislike-${props.index}`} className={styles.modalLike}>
            <div className={styles.modalLikeContent}>
                <div className={styles.wrapperCloseButton}>
                    <button
                        type="button"
                        className={`${styles.closeModalLikeReduced} ${seccion !== "B2C" ? styles.closeModalLike : ''}`}
                        onClick={() => {
                            props.statusModal();
                        }}
                        disabled={isSubmitting} // Disable close button during submission
                    >
                        x
                    </button>
                </div>
                <form method="post" onSubmit={handleSubmit}>
                    <label>Por favor, dinos cómo podemos mejorar:</label>

                    {sections.map((section, index) => (
                        <div key={index} className={styles.textAreaWrapper}>
                            <span className={styles.formSections}>{section.label}:</span>{" "}
                            <Checkbox
                                className={styles.checkboxSpacing}
                                label="Correcto"
                                type="checkbox"
                                onChange={() => handleCheckboxClick(true, section.option)}
                                checked={section.checkboxValue === true}
                                disabled={isSubmitting}
                            />{" "}
                            <Checkbox
                                className={styles.checkboxSpacing}
                                label="Incorrecto"
                                type="checkbox"
                                onChange={() => handleCheckboxClick(false, section.option)}
                                checked={section.checkboxValue === false}
                                disabled={isSubmitting}
                            />
                            {section.shouldRenderTextarea && (
                                <TextArea 
                                    placeholder={section.placeholder} 
                                    value={section.textareaValue} 
                                    onChange={section.handleTextareaChange} 
                                    disabled={isSubmitting}
                                />
                            )}
                        </div>
                    ))}
                    <div className={styles.buttonsModal}>
                        <Popup
                            content="Por favor, marque al menos una de las casillas de verificación."
                            on="click"
                            open={isPopupOpen}
                            position="top center"
                            pinned
                            trigger={
                                <button
                                    type="submit"
                                    disabled={!areCheckboxesChecked || isSubmitting || isFormSubmitted} // Disable if not checked, submitting, or already submitted
                                    onClick={e => {
                                        if (!areCheckboxesChecked) {
                                            e.preventDefault();
                                            setIsPopupOpen(true);
                                        }
                                    }}
                                >
                                    {isSubmitting ? "Enviando..." : "ENVIAR"}
                                </button>
                            }
                            onClose={() => setIsPopupOpen(false)}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};
